import { Switch } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

export default withStyles((theme) => ({
  root: {
    width: 51,
    height: 31,
    padding: 0,
    margin: 0,
  },
  switchBase: {
    padding: 1.25,
    top: 0.75,
    [theme.breakpoints.down(768)]: {
      top: 0,
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: '0.3 !important',
      backgroundColor: '#3BB200 !important',
    },
    '&$checked': {
      transform: 'translateX(21px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#34C759',
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#34C759',
      border: '3px solid #fff',
    },
  },
  thumb: {
    width: 27,
    height: 27,
  },
  track: {
    borderRadius: 31 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: '#D9D9D9',
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => (
  <Switch
    focusVisibleClassName={classes.focusVisible}
    disableRipple
    classes={{
      root: classes.root,
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: classes.track,
      checked: classes.checked,
    }}
    {...props}
  />
));
